import React from "react";
import { ParallaxBackground } from "@/components/site/ParallaxBackground";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Stats } from "@/components/site/Stats";
import { Merch } from "@/components/site/Merch";
import { Impact } from "@/components/site/Impact";
import { EventTeaser } from "@/components/site/EventTeaser";
import { PackagesSection } from "@/components/site/PackagesSection";
import { Footer } from "@/components/site/Footer";
import { EventPopup } from "@/components/site/EventPopup";

export default function Landing() {
  return (
    <div className="relative min-h-screen text-white" data-testid="landing-page">
      <ParallaxBackground />
      <Header />
      <EventPopup />
      <main>
        <Hero />
        <Marquee />
        <EventTeaser />
        <PackagesSection />
        <About />
        <Stats />
        <Merch />
        <Impact />
      </main>
      <Footer />
    </div>
  );
}
